import { useEffect, useState } from "react";

const compute = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Detroit",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value ?? "";
  const weekday = get("weekday");
  const mins = (parseInt(get("hour"), 10) % 24) * 60 + parseInt(get("minute"), 10);
  const isOpen = weekday !== "Sun" && mins >= 600 && mins < 1080;
  let label = "Closed now · Opens Mon 10 AM";
  if (isOpen) label = "Open now · until 6 PM";
  else if (weekday !== "Sun" && mins < 600) label = "Closed now · Opens 10 AM today";
  else if (weekday !== "Sat" && weekday !== "Sun") label = "Closed now · Opens 10 AM tomorrow";
  return { isOpen, label, weekday };
};

export const useOpenStatus = () => {
  const [status, setStatus] = useState(compute);
  useEffect(() => {
    const id = setInterval(() => setStatus(compute()), 60000);
    return () => clearInterval(id);
  }, []);
  return status;
};
